import { useParams } from "react-router-dom";
import { StaffTeamPageForm } from "./StaffTeamPageForm";

export function TeamPageDetail() {
  const { id } = useParams<{ id: string }>();
  if (!id) {
    return <p role="alert">Missing team page id.</p>;
  }
  return <StaffTeamPageForm mode="edit" id={id} />;
}

export default TeamPageDetail;
